import { render, staticRenderFns } from "./Grade10Curriculum.vue?vue&type=template&id=2dc462ab"
import script from "./Grade10Curriculum.vue?vue&type=script&lang=js"
export * from "./Grade10Curriculum.vue?vue&type=script&lang=js"
import style0 from "@/scss/welcome-landing.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/scss/grade-10-curriculum.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/seo/seo.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports